import { render, staticRenderFns } from "./TPrepModuleList.vue?vue&type=template&id=1d136b65"
import script from "./TPrepModuleList.vue?vue&type=script&lang=js"
export * from "./TPrepModuleList.vue?vue&type=script&lang=js"
import style0 from "./TPrepModuleList.vue?vue&type=style&index=0&id=1d136b65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports